<template>
  <div class="pay-page">
    <el-dialog
      :visible="true"
      width="1200px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closePay"
    >
      <div slot="title" class="custom-title">
        <div class="title">圆梦平台 上好大学</div>
        <div class="subtitle">
          一键冲、稳、保志愿填报<span style="margin-left: 40px"
            >畅享规划、查询、填报、问答4大核心功能</span
          >
        </div>
      </div>
      <div class="content">
        <div class="content-left">
          <div>
            <!-- <div class="hengline"></div> -->
            <div class="bigtext">会员权益</div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">学业管理</span>
            </div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">找大学</span>
            </div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">查专业</span>
            </div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">大学分数线</span>
            </div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">省控线</span>
            </div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">历年一分一段</span>
            </div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">选科大数据</span>
            </div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">志愿匹配</span>
            </div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">录取概率</span>
            </div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">志愿表</span>
            </div>
            <div class="double margin28">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">一键智能填报</span>
            </div>
            <div class="double">
              <img src="@/assets/img/vip/duigou.png" alt="" />
              <span class="text">百问百答</span>
            </div>
          </div>
          <div class="content-left-line"></div>
        </div>
        <div class="content-right">
          <div class="numstate flex" v-if="$store.state.membertype == 1">
            <img class="vipimg" src="@/assets/img/vip/numstate.png" alt="" />
          </div>
          <div
            class="content-right-moneytip"
            v-if="$store.state.membertype == 1"
          >
            <span>需支付：</span>
            <span class="money-text"
              >{{ num_money.value }}<span class="money-subtext">元</span></span
            >
          </div>
          <div class="content-tighr-tips" v-if="$store.state.membertype == 0">
            <!-- <div class="content-tighr-cover">
              <div class="tips">6月25日</div>
            </div> -->
            <!-- <img
              class="vipimg"
              v-if="timeimg == 'true'"
              src="@/assets/img/vip/time.png"
              alt=""
            /> -->
            <div class="right-title">志愿服务VIP</div>
            <div class="right-money">
              ￥<span class="big">{{ vip_money.value }}</span
              >/1年
            </div>
            <div class="right-subtitle">
              <s v-if="vip_money.value !== vip_money.description"
                >原价￥{{ vip_money.description }}</s
              >
            </div>
            <div class="right-subtitle" style="margin-top: 10px">
              有效期截至{{ vip_time }}
            </div>
          </div>
          <!-- <div class="warntips" v-if="$store.state.membertype == 0">
            {{ vip_time.text }}前注册VIP￥{{ vip_money.value }} /
            {{ vip_time.text }}后注册VIP￥{{ vip_money.description }}
          </div> -->

          <div
            class="content-right-moneytip"
            v-if="$store.state.membertype == 0"
          >
            <span>需支付：</span>
            <span class="money-text"
              >{{ vip_money.value }}<span class="money-subtext">元</span></span
            >
          </div>
          <div class="type-text">支付方式</div>
          <div class="qrcode-css">
            <div>
              <div class="qrcode-zfb flex" v-loading="!zfbqrcode">
                <!-- <img class="qrcode" v-if="zfbqrcode" :src="zfbqrcode" alt="" /> -->
                <iframe
                  :srcdoc="zfbqrcode"
                  frameborder="no"
                  border="0"
                  marginwidth="0"
                  marginheight="0"
                  scrolling="no"
                  width="115"
                  height="115"
                  style="overflow: hidden"
                >
                </iframe>
              </div>
              <div class="qrceode-tips">
                <img src="@/assets/img/vip/zfb.png" alt="" />
                <span>支付宝支付</span>
              </div>
            </div>
            <div>
              <div class="qrcode-wx" id="qrcode-wx" v-loading="!wxqrcode">
                <img class="qrcode" v-if="wxqrcode" :src="wxqrcode" alt="" />
              </div>
              <div class="qrceode-tips">
                <img src="@/assets/img/vip/wx.png" alt="" />
                <span>微信支付</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <iframe
        :srcdoc="zfbqrcode"
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
        scrolling="no"
        width="100%"
        height="100%"
        style="overflow: hidden"
      >
      </iframe> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  ajaxGetDictItems,
  gkOrdersadd,
  queryByOrderNum,
  getVipMoney,
  selectVipTime,
  selectTryVipTime,
} from "@/api/api";
import QRCode from "qrcode";
export default {
  inject: ["reload"],
  name: "vipPay",
  props: {},
  data() {
    return {
      state: false,
      timeimg: false,
      orderId: "",
      vip_money: "",
      num_money: "",
      vip_time: "",
      zfbqrcode: "",
      wxqrcode: "",
      time: "",
    };
  },
  created() {
    this.getmoney();
    this.getorderadd();
    // console.log();
  },

  methods: {
    getmoney() {
      //获取购买vip金额
      getVipMoney().then((res) => {
        if (res.success) {
          this.vip_money = res.result;
          // console.log(this.vip_money);
        }
      });
      //获取购买会员有效期
      selectVipTime().then((res) => {
        // console.log(res);
        if (res.success) {
          this.vip_time = res.result.split(" ")[0];
          // console.log(this.vip_time);
        }
      });
      //查询试用期有效期
      selectTryVipTime().then((res) => {
        // console.log(res);
        if (res.success) {
          // console.log(res);
          this.timeimg = res.result.flag;
        }
      });
      //获取购买次数金额
      ajaxGetDictItems("vip_money").then((res) => {
        if (res.success) {
          this.num_money = res.result[1];
        } else {
          this.$message.error(res.message);
        }
      });
      // ajaxGetDictItems("vip_time").then((res) => {
      //   if (res.success) {
      //     this.vip_time = res.result[0];
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    //以用户id去下单
    getorderadd() {
      let json = {
        userId: this.$store.state.userinfo.id,
        orderType: this.$store.state.membertype, //0购买会员 1购买次数
      };
      gkOrdersadd(json).then((res) => {
        // console.log(res);
        if (res.success) {
          this.orderId = res.result.orderNum;
          this.zfbqrcode = res.result.ali;
          this.QRCode(res.result.wx.codeUrl, "wxqrcode");
          this.getPayStatus();
          this.state = true;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //轮询获取订单状态1
    getPayStatus() {
      this.time = setInterval(() => {
        this.getorderstatus();
      }, 2000);
    },
    //轮询获取订单状态2
    async getorderstatus() {
      let res = await queryByOrderNum({
        orderNum: this.orderId,
      });
      if (res.result.orderStatus == 1) {
        this.$message.success("支付成功");
        clearInterval(this.time);
        this.$store.dispatch("selectUserInfo");
        this.$store.commit("setuserstate", false);
        this.reload();
        this.closePay();
      }
    },
    QRCode(text, name) {
      QRCode.toDataURL(text, (err, url) => {
        if (err) throw err;
        //将生成的二维码路径复制给data的QRImgUrl
        this[name] = url;
      });
    },
    // 关闭
    closePay() {
      this.$store.commit("setmemberstate", false);
    },
  },
  beforeDestroy() {
    clearInterval(this.time);
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  margin-top: 8vh !important;
}
/deep/.el-dialog__header {
  padding: 0px !important;
}
/deep/.el-dialog__close {
  color: #ffffff !important;
}
/deep/.el-dialog__body {
  padding: 28px 40px 40px !important;
}
.custom-title {
  height: 112px;
  background: linear-gradient(90deg, #660874, #D83379);
  background-size: cover;
  text-align: center;
  box-sizing: border-box;
  padding: 20px 0px;
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #FFFFFF;
  }
  .subtitle {
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 5px;
  }
}
.content {
  display: flex;
  .content-left {
    display: flex;
    // align-items: center;
    .hengline {
      width: 172px;
      height: 1px;
      background: #f7f7f9;
      margin-top: 20px;
      margin-bottom: 30px;
    }
    .bigtext {
      font-size: 20px;
      color: #000000;
      margin-top: 26px;
      margin-bottom: 30px;
    }
    .double {
      display: flex;
      align-items: center;
      .text {
        font-size: 16px;
        color: #000000;
        margin-left: 17px;
      }
    }
    .margin28 {
      margin-bottom: 12px;
    }
    .content-left-line {
      width: 1px;
      height: 548px;
      background: #f7f7f9;
      margin-left: 40px;
      margin-top: 20px;
    }
  }
  .content-right {
    width: 900px;
    box-sizing: border-box;
    padding-left: 40px;
    .numstate {
      width: 100%;
      justify-content: center;
      img {
        display: block;
      }
    }
    .content-tighr-tips {
      width: 600px;
      height: 200px;
      margin: 0 auto;
      background: #EFE6F1;
      border: 1px solid #620874;
      border-radius: 8px;
      position: relative;
      text-align: center;
      margin-top: 10px;
      .content-tighr-cover {
        width: 503px;
        height: 187px;
        border-radius: 8px;
        border: 1px solid transparent;
        position: absolute;
        top: -1px;
        left: 0;
        z-index: 999;
        overflow: hidden;
        .tips {
          position: absolute;
          top: 8px;
          right: -40px;
          width: 120px;
          height: 30px;
          line-height: 30px;
          transform: rotate(50deg);
          text-align: center;
          color: #ffffff;
          background-image: linear-gradient(to right, #f5955d, #fed461);
          font-size: 14px;
        }
      }
      .vipimg {
        position: absolute;
        top: -1px;
        left: -5px;
      }
      .right-title {
        font-size: 20px;
        font-weight: bold;
        color: #660874 ;
        margin-top: 20px;
      }
      .right-money {
        font-size: 20px;
        font-weight: bold;
        color: #fb481d;
        margin-top: 10px;
        .big {
          font-size: 36px !important;
        }
      }
      .right-subtitle {
        font-size: 16px;
        color: #999999;
        s {
          text-decoration: line-through;
          font-size: 16px;
          color: #fb481d;
        }
      }
    }
    .warntips {
      margin-top: 20px;
      font-size: 16px;
      color: #999999;
      text-align: center;
    }
    .content-right-moneytip {
      width: 859px;
      box-sizing: border-box;
      padding-bottom: 10px;
      text-align: center;
      background: #f7f7f9;
      border-radius: 8px;
      font-size: 20px;
      font-weight: bold;
      color: #000000;
      margin-top: 40px;
      .money-text {
        font-size: 36px;
        font-weight: bold;
        color: #fb481d;
      }
      .money-subtext {
        font-size: 18px !important;
      }
    }
    .type-text {
      font-size: 16px;
      color: #000000;
      margin-top: 45px;
    }
    .qrcode-css {
      width: 380px;
      height: 200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .qrcode-zfb {
        width: 148px;
        height: 148px;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #0084ff;
        border-radius: 8px;
        overflow: hidden;
        justify-content: center;
      }
      .qrcode-wx {
        width: 148px;
        height: 148px;
        box-sizing: border-box;
        // padding: 20px;
        background: #ffffff;
        border: 1px solid #0fca0f;
        border-radius: 8px;
        overflow: hidden;
      }
      .qrcode {
        width: 100%;
        height: 100%;
      }

      .qrceode-tips {
        display: flex;
        align-items: center;
        margin-top: 10px;
        justify-content: center;
        img {
          margin-right: 5px;
        }
        span {
          font-size: 16px;
          color: #000000;
        }
      }
    }
  }
}
</style>
